import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import classes from './SkeletonMainSeasonalSlider.module.scss';
import mainClasses from '../../../pages/Main/Main.module.scss';
import menuCardClasses from '../../../pages/Menu/MenuCard/MenuCard.module.scss';
import Skeleton from '../Skeleton';

export default function SkeletonMainSeasonalSlider() {
  const cards = [1, 2, 3, 4];

  return (
    <div className={`${mainClasses.regularSliderBox} ${mainClasses.seasonalSliderBox}`}>
      <Swiper watchOverflow spaceBetween={20} slidesPerView='auto'>
        {cards.map((_, index) => (
          <SwiperSlide className={mainClasses.seasonalSlide} key={index}>
            <div className={menuCardClasses.menuCard}>
              <div className={menuCardClasses.menuCardImg}>
                <Skeleton borderRadius='0px' width='100%' height='100%' isLight />
              </div>
              <div className={menuCardClasses.menuCardDescription}>
                <div className={classes.line1}>
                  <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
                </div>
                <div className={classes.line2}>
                  <Skeleton borderRadius='5px' width='47.5%' height={15} isLight={false} />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
